import './App.css';
import PageRoutes from './components/PageRoutes';

function App() {
	
  return (
    <div className="App">
      <PageRoutes/>
    </div>
  );
};

export default App;
